import { useCallback, useEffect, useState } from "react";

/**
 * A conservative buffer above the server's 45s resend cooldown
 * (`RESEND_COOLDOWN_MS` in `apps/api/src/modules/verifications/routes.ts`), so
 * the button re-enables only once a resend can actually succeed. Keep it at or
 * above the server value; the standard's target is a server-provided
 * `resendAvailableAt` / `retryAfterSeconds`
 * (`booking-flow.instructions.md` § verification).
 */
export const RESEND_COOLDOWN_MS = 60_000;

export function useResendCooldown() {
  const [isCoolingDown, setIsCoolingDown] = useState(false);

  const startCooldown = useCallback(() => {
    setIsCoolingDown(true);
  }, []);

  useEffect(() => {
    if (!isCoolingDown) return;

    const timeoutId = window.setTimeout(() => {
      setIsCoolingDown(false);
    }, RESEND_COOLDOWN_MS);

    return () => window.clearTimeout(timeoutId);
  }, [isCoolingDown]);

  return { isCoolingDown, startCooldown };
}
